/**
 * Default `getChildren` implementation for nodes in the AST that have no children.
 */
export var noChildren = function noChildren() {
  return [];
};

/**
 * Assign the provided node as the parent of all child nodes.
 */
export var assignParent = function assignParent(node) {
  node.getChildren().forEach(function (child) {
    child.parent = node;
  });
};